/* CircularConnex theme UI only. No tracking, intelligence data or external services. */
(() => {
  'use strict';
  function initialise(root = document) {
    if (window.Shopify?.designMode && document.body.hasAttribute('data-cc-preview-templates')) {
      root.querySelectorAll('a[href="#cc-preview-help"]').forEach(link => {
        link.addEventListener('click', () => { const help = document.getElementById('cc-preview-help'); if (help) help.open = true; });
      });
    }

    root.querySelectorAll('[data-cc-menu]').forEach(menu => {
      if (menu.dataset.ready) return;
      menu.dataset.ready = 'true';
      const trigger = menu.querySelector('summary');
      const close = (restore = false) => { menu.open = false; if (restore) trigger.focus(); };
      trigger.setAttribute('aria-expanded', String(menu.open));
      menu.addEventListener('toggle', () => trigger.setAttribute('aria-expanded', String(menu.open)));
      menu.addEventListener('keydown', event => {
        if (!menu.open) return;
        if (event.key === 'Escape') { event.preventDefault(); close(true); }
        if (event.key === 'Tab') {
          const links = [trigger, ...menu.querySelectorAll('a[href]')];
          if (event.shiftKey && document.activeElement === links[0]) { event.preventDefault(); links.at(-1).focus(); }
          else if (!event.shiftKey && document.activeElement === links.at(-1)) { event.preventDefault(); trigger.focus(); }
        }
      });
      menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => close()));
      document.addEventListener('click', event => { if (menu.isConnected && menu.open && !menu.contains(event.target)) close(); });
      window.matchMedia('(min-width: 901px)').addEventListener('change', event => { if (event.matches) close(); });
    });
    root.querySelectorAll('[data-cc-enquiry]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const group = select.form?.querySelector('[data-cc-tender]');
      if (!group) return;
      const requested = new URLSearchParams(location.search).get('enquiry');
      const types = { demonstration:'Platform demonstration', diagnostic:'Tender Diagnostic', research:'Focused research', monitoring:'Ongoing monitoring', correction:'Factual correction' };
      if (!select.value && types[requested]) select.value = types[requested];
      const update = () => { const shown = select.value === 'Tender Diagnostic'; group.hidden = !shown; group.querySelectorAll('input').forEach(input => { input.disabled = !shown; }); };
      select.addEventListener('change', update); update();
    });
    root.querySelectorAll('[data-cc-policy]').forEach(article => {
      if (article.dataset.ready) return;
      article.dataset.ready = 'true';
      const toc = article.parentElement.querySelector('[data-cc-toc]');
      if (!toc) return;
      const nav = toc.querySelector('nav');
      article.querySelectorAll('h2,h3').forEach((heading, index) => {
        if (!heading.id) {
          const baseId = `policy-section-${index + 1}`;
          let candidate = baseId;
          let suffix = 2;
          while (document.getElementById(candidate)) candidate = `${baseId}-${suffix++}`;
          heading.id = candidate;
        }
        const link = document.createElement('a'); link.href = `#${encodeURIComponent(heading.id)}`; link.textContent = heading.textContent; nav.appendChild(link);
      });
      if (nav.children.length) toc.open = matchMedia('(min-width: 701px)').matches;
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise()); else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
